<template>
  <el-dialog
    :visible="visible"
    @close="closeDialog"
    top="5vh"
    width="650px"
    center
    :title="title"
  >
    <el-form ref="uploadForm">
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="Carriers">
            <el-select
              v-model="carriersSelected"
              placeholder="Sin proveedor"
              size="small"
              clearable
              multiple
              filterable
              :disabled="loading"
              :loading="loading"
              @change="loadServices()"
              style="width:100%"
            >
              <el-option
                v-for="carrier in carriers"
                :key="carrier.uuid"
                :label="carrier.name"
                :value="carrier.name"
              >
                <span style="font-size: small;">
                  <i class="el-icon-postcard"></i>
                  {{ carrier.name }}
                </span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="Services">
            <el-select
              v-model="servicesSelected"
              placeholder="Sin proveedor"
              size="small"
              clearable
              multiple
              filterable
              :disabled="loading"
              :loading="loading"
              style="width:100%;"
            >
              <el-option
                v-for="service in services"
                :key="service.uuid"
                :label="
                  formatServiceLabel(`${service.carrier} / ${service.service}`)
                "
                :value="service.uuid"
              >
                <span style="font-size: small;">
                  <i class="el-icon-postcard"></i>
                  {{ service.carrier }} / {{ service.service }}
                </span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="[Autorización]">
            <el-input
              v-model="password"
              size="small"
              autocomplete="off"
              clearable
              type="password"
              show-password
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
      style="display: flex;justify-content: flex-end;"
    >
      <el-button
        type="warning"
        icon="el-icon-warning"
        @click="handleSave"
        round
      >
        Guardar
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { CSApi } from "@/libraries/api";

export default {
  name: "DialogDeleteByService",
  props: ["visible"],
  data() {
    return {
      title: "Eliminar coberturas por Servicio",
      carriers: [],
      services: [],
      carriersSelected: [],
      servicesSelected: [],
      loading: false,
      password: "",
    };
  },
  watch: {
    async visible() {
      const response = await CSApi().get(`/coverage/service?all=true`);

      const { data } = response.data;
      this.carriers = data.filter((service) => service.countryCode == "MX");
    },
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    update() {
      this.carriersSelected = [];
      this.servicesSelected = [];
      this.$emit("update");
    },
    formatServiceLabel(service) {
      if (service.length > 27) return `${service.substring(0, 27)}...`;
      return service;
    },
    async loadServices() {
      this.loading = true;
      const promises = this.carriersSelected.map(async (carrier) => {
        try {
          const response = await CSApi().get(
            `/coverage/service?page=1&pageSize=500&carrier=${carrier}&country=MX`
          );

          return response.data.data.filter(
            (service) => service.countryCode == "MX"
          );
        } catch (error) {
          return [];
        }
      });

      const responses = await Promise.all(promises);

      this.services = responses.flat();
      this.loading = false;
    },

    async handleSave() {
      try {
        if (!this.carriersSelected.length) throw "Select at least 1 carrier";

        const services = [];

        services.push(
          ...(this.servicesSelected.length
            ? this.servicesSelected.map((s) => s)
            : this.services.map((s) => s.uuid))
        );

        const response = await CSApi({
          "coverage-password": this.password,
        }).post(`coverage/delete/`, { services });

        if (response.data.success) {
          this.$message.success("Coberturas eliminadas exitosamente.");

          this.update();
          this.closeDialog();
          return;
        }
        this.$message.error(
          response.data.data?.error?.message ||
            "Error al eliminar las coberturas"
        );
      } catch (error) {
        this.$message.error(error.toString());
      }
    },
    async querySearchAsync(queryString, cb) {
      try {
        let services = [];

        if (!queryString) {
          const response = await CSApi().get(
            `/coverage/service?searchBy=&page=1&pageSize=500`
          );

          services = response.data.data.filter(
            (service) => service.countryCode == "MX"
          );
        } else {
          services = this.originalServices.filter(
            (service) =>
              service.carrier.includes(queryString) ||
              service.service.includes(queryString) ||
              `${service.carrier} / ${service.service}`.includes(queryString)
          );
        }

        this.services = services;

        cb(services);
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style scoped>
.el-select-dropdown__item {
  padding: 10px 20px;
  height: 55px;
  width: 330px;
}
.el-form-item__label {
  font-size: 14px;
  font-weight: 100;
  line-height: 14px;
}
.el-switch__label * {
  line-height: 1;
  font-size: 14px;
  font-weight: 100;
}
.el-input .el-input--small .el-input--suffix {
  width: 260px;
}
</style>
